import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import "./Modal.css";
import { MDBRow } from "mdb-react-ui-kit";

import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import axios from "axios";

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const CustomizedDialogs = (props) => {
  const {
    timeData1,
    setTimeData1,
    timeData3,
    setTimeData3,
    timeData2,
    setTimeData2,
    timeData4,
    setTimeData4,
    timeData5,
    setTimeData5,
    timeData6,
    setTimeData6,
    timeData7,
    setTimeData7,
    responseLoad,
    setresponseLoad,
  } = props;

  const [open, setOpen] = React.useState(false);
  const [show, setshow] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  //shanbe
  const [shanbe, setshanbe] = useState({ startTime: null, endTime: null });
  const startTimeShanbe = (e) =>
    setshanbe({ ...shanbe, startTime: e.target.value });
  const endTimeShanbe = (e) =>
    setshanbe({ ...shanbe, endTime: e.target.value });
  const [shanbeF, setshanbeF] = useState(false);

  //yekshanbe
  const [yekshanbe, setyekshanbe] = useState({
    startTime: null,
    endTime: null,
  });
  const startTimeyekshanbe = (e) =>
    setyekshanbe({ ...yekshanbe, startTime: e.target.value });
  const endTimeyekshanbe = (e) =>
    setyekshanbe({ ...yekshanbe, endTime: e.target.value });
  const [yekshanbeF, setyekshanbeF] = useState(false);

  //doshanbe
  const [doshanbe, setdoshanbe] = useState({ startTime: null, endTime: null });
  const startTimedoshanbe = (e) =>
    setdoshanbe({ ...doshanbe, startTime: e.target.value });
  const endTimedoshanbe = (e) =>
    setdoshanbe({ ...doshanbe, endTime: e.target.value });
  const [doshanbeF, setdoshanbeF] = useState(false);

  //seshanbe
  const [seshanbe, setseshanbe] = useState({ startTime: null, endTime: null });
  const startTimeseshanbe = (e) =>
    setseshanbe({ ...seshanbe, startTime: e.target.value });
  const endTimeseshanbe = (e) =>
    setseshanbe({ ...seshanbe, endTime: e.target.value });
  const [seshanbeF, setseshanbeF] = useState(false);

  //charshanbe
  const [charshanbe, setcharshanbe] = useState({
    startTime: null,
    endTime: null,
  });
  const startTimecharshanbe = (e) =>
    setcharshanbe({ ...charshanbe, startTime: e.target.value });
  const endTimecharshanbe = (e) =>
    setcharshanbe({ ...charshanbe, endTime: e.target.value });
  const [charshanbeF, setcharshanbeF] = useState(false);

  //panshanbe
  const [panshanbe, setpanshanbe] = useState({
    startTime: null,
    endTime: null,
  });
  const startTimepanshanbe = (e) =>
    setpanshanbe({ ...panshanbe, startTime: e.target.value });
  const endTimepanshanbe = (e) =>
    setpanshanbe({ ...panshanbe, endTime: e.target.value });
  const [panshanbeF, setpanshanbeF] = useState(false);

  //jome
  const [jome, setjome] = useState({ startTime: null, endTime: null });
  const startTimejome = (e) => setjome({ ...jome, startTime: e.target.value });
  const endTimejome = (e) => setjome({ ...jome, endTime: e.target.value });
  const [jomeF, setjomeF] = useState(false);

  //ALL DAY
  ////////////////////// checkbox button
  const shanbefull = (e) => {
    if (e.target.checked) {
      setshanbe({ startTime: "00:30", endTime: "24:00" });
      setshanbeF(true);
    } else {
      setshanbe({ startTime: null, endTime: null });
      setshanbeF(false);
    }
  };
  const yekfull = (e) => {
    if (e.target.checked) {
      setyekshanbe({ startTime: "00:30", endTime: "24:00" });
      setyekshanbeF(true);
    } else {
      setyekshanbe({ startTime: null, endTime: null });
      setyekshanbeF(false);
    }
  };
  const dofull = (e) => {
    if (e.target.checked) {
      setdoshanbe({ startTime: "00:30", endTime: "24:00" });
      setdoshanbeF(true);
    } else {
      setdoshanbe({ startTime: null, endTime: null });
      setdoshanbeF(false);
    }
  };
  const sefull = (e) => {
    if (e.target.checked) {
      setseshanbe({ startTime: "00:30", endTime: "24:00" });
      setseshanbeF(true);
    } else {
      setseshanbe({ startTime: null, endTime: null });
      setseshanbeF(false);
    }
  };
  const charfull = (e) => {
    if (e.target.checked) {
      setcharshanbe({ startTime: "00:30", endTime: "24:00" });
      setcharshanbeF(true);
    } else {
      setcharshanbe({ startTime: null, endTime: null });
      setcharshanbeF(false);
    }
  };
  const panjfull = (e) => {
    if (e.target.checked) {
      setpanshanbe({ startTime: "00:30", endTime: "24:00" });
      setpanshanbeF(true);
    } else {
      setpanshanbe({ startTime: null, endTime: null });
      setpanshanbeF(false);
    }
  };
  const jomefull = (e) => {
    if (e.target.checked) {
      setjome({ startTime: "00:30", endTime: "24:00" });
      setjomeF(true);
      // document.getElementById("7/2").classList.toggle("Mui-disabled");
      // console.log(document.getElementById("7/2").classList);
    } else {
      setjome({ startTime: null, endTime: null });
      setjomeF(false);
      // document.getElementById("7/2").classList.toggle("Mui-disabled");
      // console.log(document.getElementById("7/2").classList);
    }
  };

  // tatil part
  const [tatil, setTatil] = useState({
    shanbe: false,
    ye_shanbe: false,
    do_shanbe: false,
    se_shanbe: false,
    char_shanbe: false,
    panj_shanbe: false,
    jome: false,
  });

  const tatilHandler = (e, daynumb) => {
    if (e.target.checked) {
      if (daynumb === 0) {
        setTatil({ ...tatil, shanbe: true });
        setshanbe({ startTime: null, endTime: null });
      } else if (daynumb === 1) {
        setTatil({ ...tatil, ye_shanbe: true });
        setyekshanbe({ startTime: null, endTime: null });
      } else if (daynumb === 2) {
        setTatil({ ...tatil, do_shanbe: true });
        setdoshanbe({ startTime: null, endTime: null });
      } else if (daynumb === 3) {
        setTatil({ ...tatil, se_shanbe: true });
        setseshanbe({ startTime: null, endTime: null });
      } else if (daynumb === 4) {
        setTatil({ ...tatil, char_shanbe: true });
        setcharshanbe({ startTime: null, endTime: null });
      } else if (daynumb === 5) {
        setTatil({ ...tatil, panj_shanbe: true });
        setpanshanbe({ startTime: null, endTime: null });
      } else if (daynumb === 6) {
        setTatil({ ...tatil, jome: true });
        setjome({ startTime: null, endTime: null });
      }
    } else {
      if (daynumb === 0) {
        setTatil({ ...tatil, shanbe: false });
      } else if (daynumb === 1) {
        setTatil({ ...tatil, ye_shanbe: false });
      } else if (daynumb === 2) {
        setTatil({ ...tatil, do_shanbe: false });
      } else if (daynumb === 3) {
        setTatil({ ...tatil, se_shanbe: false });
      } else if (daynumb === 4) {
        setTatil({ ...tatil, char_shanbe: false });
      } else if (daynumb === 5) {
        setTatil({ ...tatil, panj_shanbe: false });
      } else if (daynumb === 6) {
        setTatil({ ...tatil, jome: false });
      }
    }
  };

  const handleClose = () => {
    // if (!props.dashBus) {
    setOpen(false);
    setshow(true);
    // setTimeData1(shanbe);

    // setresponseLoad([{}, {}, {}, {}]);
    // console.log(responseLoad);

    var x1, x2, x3, x4, x5, x6, x7;
    for (let index = 0; index < responseLoad.length; index++) {
      const element = responseLoad[index];
      // console.log("element");
      // console.log(element);
      if (element.dwId == 1) {
        x1 = {
          wtId: element.wtId,
          dwId: element.dwId,
          startTime: doshanbe.startTime,
          stopTime: doshanbe.endTime,
          open24Hours: doshanbeF,
          title: element.title,
          isClosed: tatil.do_shanbe,
        };
      } else if (element.dwId == 2) {
        x2 = {
          wtId: element.wtId,
          dwId: element.dwId,
          startTime: seshanbe.startTime,
          stopTime: seshanbe.endTime,
          open24Hours: seshanbeF,
          title: element.title,
          isClosed: tatil.se_shanbe,
        };
      } else if (element.dwId == 3) {
        x3 = {
          wtId: element.wtId,
          dwId: element.dwId,
          startTime: charshanbe.startTime,
          stopTime: charshanbe.endTime,
          open24Hours: charshanbeF,
          title: element.title,
          isClosed: tatil.char_shanbe,
        };
      } else if (element.dwId == 4) {
        x4 = {
          wtId: element.wtId,
          dwId: element.dwId,
          startTime: panshanbe.startTime,
          stopTime: panshanbe.endTime,
          open24Hours: panshanbeF,
          title: element.title,
          isClosed: tatil.panj_shanbe,
        };
      } else if (element.dwId == 5) {
        x5 = {
          wtId: element.wtId,
          dwId: element.dwId,
          startTime: jome.startTime,
          stopTime: jome.endTime,
          open24Hours: jomeF,
          title: element.title,
          isClosed: tatil.jome,
        };
      } else if (element.dwId == 6) {
        x6 = {
          wtId: element.wtId,
          dwId: element.dwId,
          startTime: shanbe.startTime,
          stopTime: shanbe.endTime,
          open24Hours: shanbeF,
          title: element.title,
          isClosed: tatil.shanbe,
        };
      } else if (element.dwId == 7) {
        x7 = {
          wtId: element.wtId,
          dwId: element.dwId,
          startTime: yekshanbe.startTime,
          stopTime: yekshanbe.endTime,
          open24Hours: yekshanbeF,
          title: element.title,
          isClosed: tatil.ye_shanbe,
        };
      }

      // setresponseLoad((responseLoad) =>
      //   responseLoad.map((r) => (r.dwId === x.dwId ? x : r))
      // );
    }
    setresponseLoad([x1, x2, x3, x4, x5, x6, x7]);

    setTimeData2(yekshanbe);
    setTimeData3(doshanbe);
    setTimeData4(seshanbe);
    setTimeData5(charshanbe);
    setTimeData6(panshanbe);
    setTimeData7(jome);
    // }
  };

  if (!props.dashBus) {
    setTimeData1(shanbe);
    setTimeData2(yekshanbe);
    setTimeData3(doshanbe);
    setTimeData4(seshanbe);
    setTimeData5(charshanbe);
    setTimeData6(panshanbe);
    setTimeData7(jome);
  }

  //api header
  const header = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
  };

  const [daysApiGet, setDaysApiGet] = useState([{}, {}, {}, {}, {}, {}, {}]);
  const [daysHour, setdaysHour] = useState([]);

  // api
  useEffect(() => {
    // console.log("responseLoad");
    // console.log(responseLoad);
    if (responseLoad) {
      setDaysApiGet(responseLoad);
      setdaysHour(props.daysHours);
      // console.log("responseLoad");
      var x = {
        startTime: responseLoad[6].startTime,
        endTime: responseLoad[6].stopTime,
      };
      // console.log(x);
      if (responseLoad[5].open24Hours) {
        setshanbeF(true);
      } else {
        setshanbeF(false);
      }
      if (responseLoad[6].open24Hours) {
        setyekshanbeF(true);
      } else {
        setyekshanbeF(false);
      }
      if (responseLoad[0].open24Hours) {
        setdoshanbeF(true);
      } else {
        setdoshanbeF(false);
      }
      if (responseLoad[1].open24Hours) {
        setseshanbeF(true);
      } else {
        setseshanbeF(false);
      }
      if (responseLoad[2].open24Hours) {
        setcharshanbeF(true);
      } else {
        setcharshanbeF(false);
      }
      if (responseLoad[3].open24Hours) {
        setpanshanbeF(true);
      } else {
        setpanshanbeF(false);
      }
      if (responseLoad[4].open24Hours) {
        setjomeF(true);
      } else {
        setjomeF(false);
      }

      setTatil({
        shanbe: responseLoad[5].isClosed,
        ye_shanbe: responseLoad[6].isClosed,
        do_shanbe: responseLoad[0].isClosed,
        se_shanbe: responseLoad[1].isClosed,
        char_shanbe: responseLoad[2].isClosed,
        panj_shanbe: responseLoad[3].isClosed,
        jome: responseLoad[4].isClosed,
      });

      setshanbe({
        startTime: responseLoad[5].startTime,
        endTime: responseLoad[5].stopTime,
      });
      setyekshanbe({
        startTime: responseLoad[6].startTime,
        endTime: responseLoad[6].stopTime,
      });
      setdoshanbe({
        startTime: responseLoad[0].startTime,
        endTime: responseLoad[0].stopTime,
      });
      setseshanbe({
        startTime: responseLoad[1].startTime,
        endTime: responseLoad[1].stopTime,
      });
      setcharshanbe({
        startTime: responseLoad[2].startTime,
        endTime: responseLoad[2].stopTime,
      });
      setpanshanbe({
        startTime: responseLoad[3].startTime,
        endTime: responseLoad[3].stopTime,
      });
      setjome({
        startTime: responseLoad[4].startTime,
        endTime: responseLoad[4].stopTime,
      });
      setshow(true);
    }

    // axios
    //   .get(domain + "/api/days-of-week", { headers: header })
    //   .then((response) => {
    //     // console.log(response.data);
    //     // setDaysApiGet(response.data.Days);
    //     // setdaysHour(response.data.Hours);
    //   })
    //   .catch((error) => {
    //     // alert(error);
    //   });

    // if (JSON.parse(localStorage.getItem("regStep6"))) {
    //   const items = JSON.parse(localStorage.getItem("regStep6"));

    // console.log("mod");
    // console.log(items.timeData1);
    // console.log(items.timeData2);
    // console.log(items.timeData3);
    // console.log(items.timeData4);
    // console.log(items.timeData5);
    // console.log(items.timeData6);
    // console.log(items.timeData7);
    // setshanbe(items.timeData1);
    // setyekshanbe(items.timeData2);
    // setdoshanbe(items.timeData3);
    // setseshanbe(items.timeData4);
    // setcharshanbe(items.timeData5);
    // setpanshanbe(items.timeData6);
    // setjome(items.timeData7);
    // setshow(true);
    // console.log(doshanbe);
    // }
  }, []);

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        id="rb-dialog-width"
        open={open}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        ></BootstrapDialogTitle>
        <DialogContent dividers id="createjob">
          <CacheProvider value={cacheRtl}>
            <ThemeProvider theme={theme}>
              <div className="s5-res-w">
                <div>
                  <h6 className="f15j">روزها و ساعت کاری</h6>

                  <MDBRow className="">
                    <p className="pmodal">
                      {daysApiGet.length > 0
                        ? daysApiGet[0].title
                          ? daysApiGet[0].title
                          : ""
                        : ""}
                    </p>
                    <div className="d-flex justify-content-md-start ">
                      <FormControl
                        className="ms-4"
                        id="step5-select1"
                        sx={{ m: 1 }}
                      >
                        <Select
                          disabled={doshanbeF || tatil.do_shanbe}
                          value={doshanbe.startTime}
                          onChange={startTimedoshanbe}
                          id="3/1"
                          // displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          <MenuItem value="" className="s5-items">
                            <em>
                              <p></p>
                            </em>
                          </MenuItem>
                          {daysHour.map((item) => (
                            <MenuItem
                              className="s5-items"
                              key={item.hour}
                              value={item.hour}
                              disabled={
                                doshanbe.endTime &&
                                doshanbe.endTime <= item.hour
                              }
                            >
                              {item.hour}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <FormControl id="step5-select1" sx={{ m: 1 }}>
                        <Select
                          disabled={doshanbeF || tatil.do_shanbe}
                          className=""
                          value={doshanbe.endTime}
                          onChange={endTimedoshanbe}
                          id="3/2"
                          // displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          <MenuItem value="" className="s5-items">
                            <em>
                              <p></p>
                            </em>
                          </MenuItem>
                          {daysHour.map((item) => (
                            <MenuItem
                              className="s5-items"
                              key={item.hour}
                              value={item.hour}
                              disabled={
                                doshanbe.startTime &&
                                doshanbe.startTime >= item.hour
                              }
                            >
                              {item.hour}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </MDBRow>
                  <div className="d-flex">
                    <label
                      className={
                        !tatil.do_shanbe
                          ? "container-s5 "
                          : "container-s5 disabled "
                      }
                    >
                      <input
                        type="checkbox"
                        disabled={tatil.do_shanbe}
                        onChange={dofull}
                        defaultChecked={responseLoad[0].open24Hours}
                      />
                      <span className="s5-24h"></span>
                      <span className="s5-modal24">24 ساعته </span>
                    </label>
                    <label
                      className={
                        !doshanbeF
                          ? "container-s5 me-5"
                          : "container-s5 disabled me-5"
                      }
                    >
                      <input
                        type="checkbox"
                        disabled={doshanbeF}
                        onChange={(e) => tatilHandler(e, 2)}
                        defaultChecked={tatil.do_shanbe}
                      />
                      <span className="s5-24h"></span>
                      <span className="s5-modal24">تعطیل </span>
                    </label>
                  </div>
                  <MDBRow className="">
                    <p className="pmodal">
                      {daysApiGet.length > 0
                        ? daysApiGet[1].title
                          ? daysApiGet[1].title
                          : ""
                        : ""}
                    </p>
                    <div className="d-flex justify-content-md-start ">
                      <FormControl
                        className="ms-4"
                        id="step5-select1"
                        sx={{ m: 1 }}
                      >
                        <Select
                          disabled={seshanbeF || tatil.se_shanbe}
                          value={seshanbe.startTime}
                          onChange={startTimeseshanbe}
                          id="4/1"
                          // displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          <MenuItem value="" className="s5-items">
                            <em>
                              <p></p>
                            </em>
                          </MenuItem>
                          {daysHour.map((item) => (
                            <MenuItem
                              className="s5-items"
                              key={item.hour}
                              value={item.hour}
                              disabled={
                                seshanbe.endTime &&
                                seshanbe.endTime <= item.hour
                              }
                            >
                              {item.hour}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <FormControl id="step5-select1" sx={{ m: 1 }}>
                        <Select
                          disabled={seshanbeF || tatil.se_shanbe}
                          value={seshanbe.endTime}
                          onChange={endTimeseshanbe}
                          id="4/2"
                          // displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          <MenuItem value="" className="s5-items">
                            <em>
                              <p></p>
                            </em>
                          </MenuItem>
                          {daysHour.map((item) => (
                            <MenuItem
                              className="s5-items"
                              key={item.hour}
                              value={item.hour}
                              disabled={
                                seshanbe.startTime &&
                                seshanbe.startTime >= item.hour
                              }
                            >
                              {item.hour}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </MDBRow>
                  <div className="d-flex">
                    <label
                      className={
                        !tatil.se_shanbe
                          ? "container-s5 "
                          : "container-s5 disabled "
                      }
                    >
                      <input
                        type="checkbox"
                        disabled={tatil.se_shanbe}
                        onChange={sefull}
                        defaultChecked={responseLoad[1].open24Hours}
                      />
                      <span className="s5-24h"></span>
                      <span className="s5-modal24">24 ساعته </span>
                    </label>
                    <label
                      className={
                        !seshanbeF
                          ? "container-s5 me-5"
                          : "container-s5 disabled me-5"
                      }
                    >
                      <input
                        type="checkbox"
                        disabled={seshanbeF}
                        onChange={(e) => tatilHandler(e, 3)}
                        defaultChecked={tatil.se_shanbe}
                      />
                      <span className="s5-24h"></span>
                      <span className="s5-modal24">تعطیل </span>
                    </label>
                  </div>
                  <MDBRow className="">
                    <p className="pmodal">
                      {daysApiGet.length > 0
                        ? daysApiGet[2].title
                          ? daysApiGet[2].title
                          : ""
                        : ""}
                    </p>
                    <div className="d-flex justify-content-md-start ">
                      <FormControl
                        className="ms-4"
                        id="step5-select1"
                        sx={{ m: 1 }}
                      >
                        <Select
                          disabled={charshanbeF || tatil.char_shanbe}
                          value={charshanbe.startTime}
                          onChange={startTimecharshanbe}
                          id="5/1"
                          // displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          <MenuItem value="" className="s5-items">
                            <em>
                              <p></p>
                            </em>
                          </MenuItem>
                          {daysHour.map((item) => (
                            <MenuItem
                              className="s5-items"
                              key={item.hour}
                              value={item.hour}
                              disabled={
                                charshanbe.endTime &&
                                charshanbe.endTime <= item.hour
                              }
                            >
                              {item.hour}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <FormControl id="step5-select1" sx={{ m: 1 }}>
                        <Select
                          disabled={charshanbeF || tatil.char_shanbe}
                          value={charshanbe.endTime}
                          onChange={endTimecharshanbe}
                          id="5/2"
                          // displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          <MenuItem value="" className="s5-items">
                            <em>
                              <p></p>
                            </em>
                          </MenuItem>
                          {daysHour.map((item) => (
                            <MenuItem
                              className="s5-items"
                              key={item.hour}
                              value={item.hour}
                              disabled={
                                charshanbe.startTime &&
                                charshanbe.startTime >= item.hour
                              }
                            >
                              {item.hour}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </MDBRow>
                  <div className="d-flex">
                    <label
                      className={
                        !tatil.char_shanbe
                          ? "container-s5 "
                          : "container-s5 disabled "
                      }
                    >
                      <input
                        type="checkbox"
                        disabled={tatil.char_shanbe}
                        onChange={charfull}
                        defaultChecked={responseLoad[2].open24Hours}
                      />
                      <span className="s5-24h"></span>
                      <span className="s5-modal24">24 ساعته </span>
                    </label>
                    <label
                      className={
                        !charshanbeF
                          ? "container-s5 me-5"
                          : "container-s5 disabled me-5"
                      }
                    >
                      <input
                        type="checkbox"
                        disabled={charshanbeF}
                        onChange={(e) => tatilHandler(e, 4)}
                        defaultChecked={tatil.char_shanbe}
                      />
                      <span className="s5-24h"></span>
                      <span className="s5-modal24">تعطیل </span>
                    </label>
                  </div>

                  <MDBRow className="">
                    <p className="pmodal">
                      {daysApiGet.length > 0
                        ? daysApiGet[3].title
                          ? daysApiGet[3].title
                          : ""
                        : ""}
                    </p>
                    <div className="d-flex justify-content-md-start ">
                      <FormControl
                        className="ms-4"
                        id="step5-select1"
                        sx={{ m: 1 }}
                      >
                        <Select
                          disabled={panshanbeF || tatil.panj_shanbe}
                          value={panshanbe.startTime}
                          onChange={startTimepanshanbe}
                          id="6/1"
                          // displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          <MenuItem value="" className="s5-items">
                            <em>
                              <p></p>
                            </em>
                          </MenuItem>
                          {daysHour.map((item) => (
                            <MenuItem
                              className="s5-items"
                              key={item.hour}
                              value={item.hour}
                              disabled={
                                panshanbe.endTime &&
                                panshanbe.endTime <= item.hour
                              }
                            >
                              {item.hour}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <FormControl id="step5-select1" sx={{ m: 1 }}>
                        <Select
                          disabled={panshanbeF || tatil.panj_shanbe}
                          value={panshanbe.endTime}
                          onChange={endTimepanshanbe}
                          id="6/2"
                          // displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          <MenuItem value="" className="s5-items">
                            <em>
                              <p></p>
                            </em>
                          </MenuItem>
                          {daysHour.map((item) => (
                            <MenuItem
                              className="s5-items"
                              key={item.hour}
                              value={item.hour}
                              disabled={
                                panshanbe.startTime &&
                                panshanbe.startTime >= item.hour
                              }
                            >
                              {item.hour}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </MDBRow>
                  <div className="d-flex">
                    <label
                      className={
                        !tatil.panj_shanbe
                          ? "container-s5 "
                          : "container-s5 disabled "
                      }
                    >
                      <input
                        type="checkbox"
                        disabled={tatil.panj_shanbe}
                        onChange={panjfull}
                        defaultChecked={responseLoad[3].open24Hours}
                      />
                      <span className="s5-24h"></span>
                      <span className="s5-modal24">24 ساعته </span>
                    </label>
                    <label
                      className={
                        !panshanbeF
                          ? "container-s5 me-5"
                          : "container-s5 disabled me-5"
                      }
                    >
                      <input
                        type="checkbox"
                        disabled={panshanbeF}
                        onChange={(e) => tatilHandler(e, 5)}
                        defaultChecked={tatil.panj_shanbe}
                      />
                      <span className="s5-24h"></span>
                      <span className="s5-modal24">تعطیل </span>
                    </label>
                  </div>
                  <MDBRow className="">
                    <p className="pmodal">
                      {daysApiGet.length > 0
                        ? daysApiGet[4].title
                          ? daysApiGet[4].title
                          : ""
                        : ""}
                    </p>
                    <div className="d-flex justify-content-md-start ">
                      <FormControl
                        className="ms-4"
                        id="step5-select1"
                        sx={{ m: 1 }}
                      >
                        <Select
                          disabled={jomeF || tatil.jome}
                          value={jome.startTime}
                          onChange={startTimejome}
                          id="7/1"
                          // displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          <MenuItem value="" className="s5-items">
                            <em>
                              <p></p>
                            </em>
                          </MenuItem>
                          {daysHour.map((item) => (
                            <MenuItem
                              className="s5-items"
                              key={item.hour}
                              value={item.hour}
                              disabled={
                                jome.endTime && jome.endTime <= item.hour
                              }
                            >
                              {item.hour}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <FormControl id="step5-select1" sx={{ m: 1 }}>
                        <Select
                          disabled={jomeF || tatil.jome}
                          value={jome.endTime}
                          onChange={endTimejome}
                          id="7/2"
                          // displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          <MenuItem value="" className="s5-items">
                            <em>
                              <p></p>
                            </em>
                          </MenuItem>
                          {daysHour.map((item) => (
                            <MenuItem
                              className="s5-items"
                              key={item.hour}
                              value={item.hour}
                              disabled={
                                jome.startTime && jome.startTime >= item.hour
                              }
                            >
                              {item.hour}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </MDBRow>
                  <div className="d-flex">
                    <label
                      className={
                        !tatil.jome ? "container-s5 " : "container-s5 disabled "
                      }
                    >
                      <input
                        type="checkbox"
                        disabled={tatil.jome}
                        onChange={jomefull}
                        defaultChecked={responseLoad[4].open24Hours}
                      />
                      <span className="s5-24h"></span>
                      <span className="s5-modal24">24 ساعته </span>
                    </label>
                    <label
                      className={
                        !jomeF
                          ? "container-s5 me-5"
                          : "container-s5 disabled me-5"
                      }
                    >
                      <input
                        type="checkbox"
                        disabled={jomeF}
                        onChange={(e) => tatilHandler(e, 6)}
                        defaultChecked={tatil.jome}
                      />
                      <span className="s5-24h"></span>
                      <span className="s5-modal24">تعطیل </span>
                    </label>
                  </div>

                  <MDBRow className=" ">
                    <p className="pmodal">
                      {daysApiGet.length > 0
                        ? daysApiGet[5].title
                          ? daysApiGet[5].title
                          : ""
                        : ""}
                    </p>
                    <div className="d-flex justify-content-md-start ">
                      <FormControl
                        className="ms-4 "
                        id="step5-select1"
                        sx={{ m: 1 }}
                      >
                        <Select
                          disabled={shanbeF || tatil.shanbe}
                          value={shanbe.startTime}
                          onChange={startTimeShanbe}
                          id="2/1"
                          // displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          <MenuItem value="" className="s5-items">
                            <em>
                              <p></p>
                            </em>
                          </MenuItem>
                          {daysHour.map((item) => (
                            <MenuItem
                              className="s5-items"
                              key={item.hour}
                              value={item.hour}
                              disabled={
                                shanbe.endTime && shanbe.endTime <= item.hour
                              }
                            >
                              {item.hour}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <FormControl id="step5-select1" sx={{ m: 1 }}>
                        <Select
                          disabled={shanbeF || tatil.shanbe}
                          className=""
                          value={shanbe.endTime}
                          onChange={endTimeShanbe}
                          id="2/2"
                          // displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          <MenuItem value="" className="s5-items">
                            <em>
                              <p></p>
                            </em>
                          </MenuItem>
                          {daysHour.map((item) => (
                            <MenuItem
                              className="s5-items"
                              key={item.hour}
                              value={item.hour}
                              disabled={
                                shanbe.startTime &&
                                shanbe.startTime >= item.hour
                              }
                            >
                              {item.hour}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </MDBRow>
                  <div className="d-flex">
                    <label
                      className={
                        !tatil.shanbe
                          ? "container-s5 "
                          : "container-s5 disabled "
                      }
                    >
                      <input
                        type="checkbox"
                        disabled={tatil.shanbe}
                        onChange={shanbefull}
                        defaultChecked={responseLoad[5].open24Hours}
                      />
                      <span className="s5-24h"></span>
                      <span className="s5-modal24">24 ساعته </span>
                    </label>
                    <label
                      className={
                        !shanbeF
                          ? "container-s5 me-5"
                          : "container-s5 disabled me-5"
                      }
                    >
                      <input
                        type="checkbox"
                        disabled={shanbeF}
                        onChange={(e) => tatilHandler(e, 0)}
                        defaultChecked={tatil.shanbe}
                      />
                      <span className="s5-24h"></span>
                      <span className="s5-modal24">تعطیل </span>
                    </label>
                  </div>
                  <MDBRow className=" ">
                    <p className="pmodal">
                      {daysApiGet.length > 0
                        ? daysApiGet[6].title
                          ? daysApiGet[6].title
                          : ""
                        : ""}
                    </p>
                    <div className="d-flex justify-content-md-start ">
                      <FormControl
                        className="ms-4 "
                        id="step5-select1"
                        sx={{ m: 1 }}
                      >
                        <Select
                          disabled={yekshanbeF || tatil.ye_shanbe}
                          value={yekshanbe.startTime}
                          onChange={startTimeyekshanbe}
                          id="2/1"
                          // displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          <MenuItem value="" className="s5-items">
                            <em>
                              <p></p>
                            </em>
                          </MenuItem>
                          {daysHour.map((item) => (
                            <MenuItem
                              className="s5-items"
                              key={item.hour}
                              value={item.hour}
                              disabled={
                                yekshanbe.endTime &&
                                yekshanbe.endTime <= item.hour
                              }
                            >
                              {item.hour}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <FormControl id="step5-select1" sx={{ m: 1 }}>
                        <Select
                          disabled={yekshanbeF || tatil.ye_shanbe}
                          className=""
                          value={yekshanbe.endTime}
                          onChange={endTimeyekshanbe}
                          id="2/2"
                          // displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          <MenuItem value="" className="s5-items">
                            <em>
                              <p></p>
                            </em>
                          </MenuItem>
                          {daysHour.map((item) => (
                            <MenuItem
                              className="s5-items"
                              key={item.hour}
                              value={item.hour}
                              disabled={
                                yekshanbe.startTime &&
                                yekshanbe.startTime >= item.hour
                              }
                            >
                              {item.hour}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </MDBRow>
                  <div className="d-flex">
                    <label
                      className={
                        !tatil.ye_shanbe
                          ? "container-s5 "
                          : "container-s5 disabled "
                      }
                    >
                      <input
                        type="checkbox"
                        disabled={tatil.ye_shanbe}
                        onChange={yekfull}
                        defaultChecked={responseLoad[6].open24Hours}
                      />
                      <span className="s5-24h"></span>
                      <span className="s5-modal24">24 ساعته </span>
                    </label>
                    <label
                      className={
                        !yekshanbeF
                          ? "container-s5 me-5"
                          : "container-s5 disabled me-5"
                      }
                    >
                      <input
                        type="checkbox"
                        disabled={yekshanbeF}
                        onChange={(e) => tatilHandler(e, 1)}
                        defaultChecked={tatil.ye_shanbe}
                      />
                      <span className="s5-24h"></span>
                      <span className="s5-modal24">تعطیل </span>
                    </label>
                  </div>
                  {/* <input
                          type="checkbox"
                          className="mt-4 s5-24h"
                          onChange={jomefull}
                        />{" "}
                        <span className="s5-modal24">24 ساعته  </span> */}
                  {/* {yekshanbe.startTime &&
                    yekshanbe.endTime &&
                    yekshanbe.startTime >= yekshanbe.endTime && (
                      <span className="input-error-time-modal">
                        ساعتِ واردشده اشتباه است. لطفا ترتیب ساعت را رعایت کنید.
                      </span>
                    )} */}
                </div>
              </div>
            </ThemeProvider>
          </CacheProvider>
        </DialogContent>
        <DialogActions id="s5-modal-bottom">
          <button className="s5-modal-save hov-shadow" onClick={handleClose}>
            ذخیره
          </button>
        </DialogActions>
      </BootstrapDialog>
      {show &&
      ((shanbe.startTime !== null && shanbe.startTime !== "") ||
        (shanbe.endTime !== null && shanbe.endTime !== "") ||
        (yekshanbe.startTime !== null && yekshanbe.startTime !== "") ||
        (yekshanbe.endTime !== null && yekshanbe.endTime !== "") ||
        (doshanbe.startTime !== null && doshanbe.startTime !== "") ||
        (doshanbe.endTime !== null && doshanbe.endTime !== "") ||
        (seshanbe.startTime !== null && seshanbe.startTime !== "") ||
        (seshanbe.endTime !== null && seshanbe.endTime !== "") ||
        (charshanbe.startTime !== null && charshanbe.startTime !== "") ||
        (charshanbe.endTime !== null && charshanbe.endTime !== "") ||
        (panshanbe.startTime !== null && panshanbe.startTime !== "") ||
        (panshanbe.endTime !== null && panshanbe.endTime !== "") ||
        (jome.startTime !== null && jome.startTime !== "") ||
        (jome.endTime !== null && jome.endTime !== "")) ? (
        <div
          className={
            props.dashBus ? "s5-days-color-resp dash-bus" : "s5-days-color-resp"
          }
        >
          <div className="div-days-show">
            {/* <MDBContainer> */}
            <div className="d-none d-md-flex justify-content-md-start justify-content-between mt-md-4">
              <div className="s5-w-95px d-md-block d-none">
                <p className="s5-modal-days">{daysApiGet[0].title}</p>
                {tatil.do_shanbe ? (
                  <p className="s5-times-resp fs-14">تعطیل</p>
                ) : (
                  <p className="s5-times-resp">
                    <small>{doshanbe.startTime}</small>
                    <small>-</small>
                    <small>{doshanbe.endTime}</small>
                  </p>
                )}
              </div>
              <div className="s5-w-95px d-md-block d-none">
                <p className="s5-modal-days">{daysApiGet[1].title}</p>
                {tatil.se_shanbe ? (
                  <p className="s5-times-resp fs-14">تعطیل</p>
                ) : (
                  <p className="s5-times-resp">
                    <small>{seshanbe.startTime}</small>
                    <small>-</small>
                    <small>{seshanbe.endTime}</small>
                  </p>
                )}
              </div>
              <div className="s5-w-95px s5-w-95px-resp">
                <p className="s5-modal-days">{daysApiGet[2].title}</p>
                {tatil.char_shanbe ? (
                  <p className="s5-times-resp fs-14">تعطیل</p>
                ) : (
                  <p className="s5-times-resp">
                    <small>{charshanbe.startTime}</small>
                    <small>-</small>
                    <small>{charshanbe.endTime}</small>
                  </p>
                )}
              </div>
              <div className="s5-w-95px s5-w-95px-resp2">
                <p className="s5-modal-days">{daysApiGet[3].title}</p>
                {tatil.panj_shanbe ? (
                  <p className="s5-times-resp fs-14">تعطیل</p>
                ) : (
                  <p className="s5-times-resp">
                    <small>{panshanbe.startTime}</small>
                    <small>-</small>
                    <small>{panshanbe.endTime}</small>
                  </p>
                )}
              </div>
            </div>
            <div className="d-none d-md-flex justify-content-md-start justify-content-between">
              <div className="s5-w-95px d-md-block d-none">
                <p className="s5-modal-days">{daysApiGet[4].title}</p>
                {tatil.jome ? (
                  <p className="s5-times-resp fs-14">تعطیل</p>
                ) : (
                  <p className="s5-times-resp">
                    <small>{jome.startTime}</small>
                    <small>-</small>
                    <small>{jome.endTime}</small>
                  </p>
                )}
              </div>
              <div className="s5-w-95px s5-w-95px-resp">
                <p className="s5-modal-days">{daysApiGet[5].title}</p>
                {tatil.shanbe ? (
                  <p className="s5-times-resp fs-14">تعطیل</p>
                ) : (
                  <p className="s5-times-resp">
                    <small>{shanbe.startTime}</small>
                    <small>-</small>
                    <small>{shanbe.endTime}</small>
                  </p>
                )}
              </div>
              <div className="s5-w-95px s5-w-95px-resp2">
                <p className="s5-modal-days">{daysApiGet[6].title}</p>
                {tatil.ye_shanbe ? (
                  <p className="s5-times-resp fs-14">تعطیل</p>
                ) : (
                  <p className="s5-times-resp">
                    <small>{yekshanbe.startTime}</small>
                    <small>-</small>
                    <small>{yekshanbe.endTime}</small>
                  </p>
                )}
              </div>
            </div>
            {/* just responsive */}
            <div className="d-md-none d-flex justify-content-around">
              <div className="">
                <div className="-resp">
                  <p className="s5-modal-days">{daysApiGet[0].title}</p>
                  {tatil.do_shanbe ? (
                    <p className="s5-times-resp fs-14">تعطیل</p>
                  ) : (
                    <p className="s5-times-resp">
                      <small>{doshanbe.startTime}</small>
                      <small>-</small>
                      <small>{doshanbe.endTime}</small>
                    </p>
                  )}
                </div>
                <div className="">
                  <p className="s5-modal-days">{daysApiGet[2].title}</p>
                  {tatil.char_shanbe ? (
                    <p className="s5-times-resp fs-14">تعطیل</p>
                  ) : (
                    <p className="s5-times-resp">
                      <small>{charshanbe.startTime}</small>
                      <small>-</small>
                      <small>{charshanbe.endTime}</small>
                    </p>
                  )}
                </div>
                <div className=" ">
                  <p className="s5-modal-days">{daysApiGet[4].title}</p>
                  {tatil.jome ? (
                    <p className="s5-times-resp fs-14">تعطیل</p>
                  ) : (
                    <p className="s5-times-resp">
                      <small>{jome.startTime}</small>
                      <small>-</small>
                      <small>{jome.endTime}</small>
                    </p>
                  )}
                </div>
                <div className="">
                  <p className="s5-modal-days">{daysApiGet[6].title}</p>
                  {tatil.ye_shanbe ? (
                    <p className="s5-times-resp fs-14">تعطیل</p>
                  ) : (
                    <p className="s5-times-resp">
                      <small>{yekshanbe.startTime}</small>
                      <small>-</small>
                      <small>{yekshanbe.endTime}</small>
                    </p>
                  )}
                </div>
              </div>
              <div className="">
                <div className="">
                  <p className="s5-modal-days">{daysApiGet[1].title}</p>
                  {tatil.se_shanbe ? (
                    <p className="s5-times-resp fs-14">تعطیل</p>
                  ) : (
                    <p className="s5-times-resp">
                      <small>{seshanbe.startTime}</small>
                      <small>-</small>
                      <small>{seshanbe.endTime}</small>
                    </p>
                  )}
                </div>
                <div className="">
                  <p className="s5-modal-days">{daysApiGet[3].title}</p>
                  {tatil.panj_shanbe ? (
                    <p className="s5-times-resp fs-14">تعطیل</p>
                  ) : (
                    <p className="s5-times-resp">
                      <small>{panshanbe.startTime}</small>
                      <small>-</small>
                      <small>{panshanbe.endTime}</small>
                    </p>
                  )}
                </div>
                <div className="">
                  <p className="s5-modal-days">{daysApiGet[5].title}</p>
                  {tatil.shanbe ? (
                    <p className="s5-times-resp fs-14">تعطیل</p>
                  ) : (
                    <p className="s5-times-resp">
                      <small>{shanbe.startTime}</small>
                      <small>-</small>
                      <small>{shanbe.endTime}</small>
                    </p>
                  )}
                </div>
              </div>
            </div>
            {/* just responsive end */}
          </div>
        </div>
      ) : (
        ""
      )}
      {!show ||
      ((shanbe.startTime == null || shanbe.startTime == "") &&
        (shanbe.endTime == null || shanbe.endTime == "") &&
        (yekshanbe.startTime == null || yekshanbe.startTime == "") &&
        (yekshanbe.endTime == null || yekshanbe.endTime == "") &&
        (doshanbe.startTime == null || doshanbe.startTime == "") &&
        (doshanbe.endTime == null || doshanbe.endTime == "") &&
        (seshanbe.startTime == null || seshanbe.startTime == "") &&
        (seshanbe.endTime == null || seshanbe.endTime == "") &&
        (charshanbe.startTime == null || charshanbe.startTime == "") &&
        (charshanbe.endTime == null || charshanbe.endTime == "") &&
        (panshanbe.startTime == null || panshanbe.startTime == "") &&
        (panshanbe.endTime == null || panshanbe.endTime == "") &&
        (jome.startTime == null || jome.startTime == "") &&
        (jome.endTime == null || jome.endTime == "&&")) ? (
        <div className="text-center text-md-end">
          <button
            className={props.dashBus ? "s5-modal-btn dash-bus" : "s5-modal-btn"}
            onClick={handleClickOpen}
            disabled={props.isFull}
          >
            اضافه کردن زمان‌های کاری هفته
          </button>
        </div>
      ) : (
        <div className="text-center text-md-end">
          <button
            className={
              props.dashBus
                ? "s5-modal-btn s5-modal-btn2 dash-bus"
                : "s5-modal-btn s5-modal-btn2"
            }
            onClick={handleClickOpen}
            disabled={props.isFull}
          >
            ویرایش زمان‌های کاری
          </button>
        </div>
      )}
    </div>
  );
};
export default CustomizedDialogs;
